<template>
    <div class="container">
        <div class="text-wrapper">
            <p class="contact">Contact</p>
            <p class="title">Join with me for Upskill.</p>
            <p class="description">Boost your expertise and stay ahead with focused learning.</p>
        </div>
        <div class="email-wrapper">
            <input class="input-text" v-model="emailId" type="text" placeholder="Your Email Id">
            <div class="button">
                <button class="connect" :disabled="sendingRequest" @click="onSubscribe">
                    Connect
                </button>
            </div>
        </div>
        <div class="dummy-wrapper"></div>

        <v-snackbar v-model="showToaster" timeout='4000' color="#252626">
            <div class="toaster-card">
                <img :src="require('@/assets/icons/success-icon.svg')" v-if="toasterType == 'success'" />
                <img :src="require('@/assets/icons/error-icon.svg')" v-else />
                <p class="toaster-text">{{ toasterMsg }}</p>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'ContactComponent',
    data() {
        return {
            emailId: '',
            showToaster: false,
            toasterMsg: '',
            toasterType: '',
            sendingRequest: false,
            backendUrl: process.env.VUE_APP_BACKEND_URL,
        }
    },
    methods: {
        onsubmit(){
            this.showToaster = true;
        },
        validateFields() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.emailId.trim())) {
                return false;
            }
            return true;
        },

        async onSubscribe() {
            this.sendingRequest = true;
            if (!this.validateFields()) {
                this.toasterMsg = 'Invalid Email Id. Please check your Email Id';
                this.showToaster = true;
                this.toasterType = 'error';
                this.sendingRequest = false;
                return;
            }
            
            let payload = {
                emailId: this.emailId.trim(),
            };
            axios.post(this.backendUrl + '/subscribe', payload )
                .then(response => {
                    console.log('response', response);
                    if(response.status == 201) {
                        this.toasterMsg = response.data.message;
                        this.showToaster = true;
                        this.toasterType = 'error';
                        this.sendingRequest = false;
                    } else {
                        this.toasterMsg = 'You’re all set! We’ll be in touch soon.';
                        this.showToaster = true;
                        this.toasterType = 'success';
                        this.sendingRequest = false;
                    }
                    this.emailId = '';
                })
                .catch(error => {
                    this.toasterMsg = 'Oops! Something went wrong';
                    this.showToaster = true;
                    this.toasterType = 'error';
                    this.sendingRequest = false;
                    console.error(error);
                });
        }
    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 80px 120px;
    display: flex;
    gap: 32px;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.text-wrapper {
    display: flex;
    gap: 12px;
    flex-direction: column;
    text-align: center;
    z-index: 99;
}

.contact {
    font-size: 24px;
    font-weight: 600;
    background: linear-gradient(#B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.title {
    font-size: 2rem;
    font-weight: 600;
    color: var(--primary-text-color);
}

.description {
    font-size: 18px;
    color: var(--secondary-text-color);
}

.email-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    position: relative;
}

.input-text {
    border-radius: 500px;
    border: 2px solid #252626;
    background-color: #151616;
    padding: 12px 125px 12px 16px;
    outline: none;
    box-shadow: 0px 0px 10px 0px #0000001A;
    width: 400px;
}

.button {
    position: absolute;
    top: 50%;
    transform: translate(123%, -50%);
}

.connect {
    border-radius: 500px;
    background-color: #151616;
    padding: 12px 24px;
    outline: none;
    border: none;
    outline: none;
    position: relative;
    background: linear-gradient(#B66BE1, #FF6267, #FFA84B);
    cursor: pointer;
    overflow: hidden;
    color: var(--primary-text-color);
}

.connect:disabled::before {
    content: 'Connecting...';
}

.connect::before {
    content: "Connect";
    position: absolute;
    top: 2px;
    right: 2px;
    bottom: 2px;
    left: 2px;
    background-color: #151616;
    border-radius: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dummy-wrapper {
    background: radial-gradient(50% 50% at 50% 50%, #3F1D6A 0%, #A83AFF 20.02%, #7E30CC 41.93%, rgba(135, 38, 181, 0.5) 74.15%, rgba(82, 7, 157, 0) 100%);
    width: 88%;
    height: 700px;
    position: absolute;
    top: 150px;
}

@media (max-width: 700px)  {
    .container {
        padding: 32px;
        gap: 32px;
    }

    .contact {
        font-size: 0.9rem;
    }

    .title {
        font-size: 1.2rem;
    }

    .description {
        font-size: 1rem;
    }

    .tabs-wrapper {
        flex-direction: column;
    }

    .dummy-wrapper {
        top: 200px;
    }

    .text-wrapper {
        text-align: left;
    }

    .input-text {
        width: 300px;
    }

    .button {
        transform: translate(80%, -50%);
    }
}
</style>